import { IMAGES } from "./site";

export const SERVICE_CATEGORIES = [
  {
    id: "ultrasound",
    title: "Ultrasound",
    icon: "Waves",
    image: IMAGES.ultrasound,
    blurb:
      "High-resolution 4D ultrasound & colour Doppler studies performed by experienced radiologists.",
    services: [
      { name: "Abdomen USG", desc: "Detailed scan of liver, gallbladder, pancreas, spleen & kidneys to detect stones, cysts and organ abnormalities." },
      { name: "USG KUB + PVR", desc: "Kidney, ureter & bladder scan with post-void residual urine assessment." },
      { name: "Pelvic Scan", desc: "Evaluation of the lower abdomen and pelvic organs for both men and women." },
      { name: "Scrotal USG + Doppler", desc: "Scrotal imaging with blood-flow study to assess pain, swelling and varicocele." },
      { name: "Arterial Doppler of Limbs", desc: "Colour Doppler to evaluate arterial blood flow and blockages in the limbs." },
      { name: "Venous Doppler of Limbs", desc: "Detects deep vein thrombosis (DVT) and venous insufficiency in arms or legs." },
      { name: "USG Soft Tissue", desc: "Focused imaging of lumps, swellings and superficial soft-tissue structures." },
      { name: "Musculoskeletal USG", desc: "Assessment of muscles, tendons, ligaments and joints for injuries." },
      { name: "Thyroid & Neck Scan", desc: "Evaluates thyroid nodules, goitre and neck lymph nodes." },
      { name: "Carotid Doppler", desc: "Screens carotid arteries for plaque and stroke-risk assessment." },
      { name: "USG Breast", desc: "Radiation-free breast imaging for lumps and dense breast evaluation." },
      { name: "Neurosonogram", desc: "Brain ultrasound for infants to assess neurological development." },
      { name: "Transvaginal Scan", desc: "Detailed pelvic imaging for gynaecological and early pregnancy assessment." },
      { name: "Obstetric Scan", desc: "Monitoring fetal growth, position and wellbeing during pregnancy." },
      { name: "FNAC Biopsy", desc: "Ultrasound-guided fine-needle aspiration cytology for accurate sampling." },
      { name: "Routine Obstetric USG", desc: "Standard pregnancy ultrasound for routine antenatal checks." },
    ],
  },
  {
    id: "xray",
    title: "X-Ray Investigations",
    icon: "ScanLine",
    image: IMAGES.xray,
    blurb:
      "Low-dose Digital X-Ray with instant, crisp imaging across chest, spine, bone and joints.",
    services: [
      { name: "Digital X-Ray", desc: "Fast, low-radiation digital radiography with high-clarity images." },
      { name: "X-Ray KUB Region", desc: "Plain X-ray of kidney, ureter & bladder region to detect stones." },
      { name: "X-Ray Chest", desc: "Evaluates lungs, heart and chest wall for infection and abnormalities." },
      { name: "X-Ray Spine", desc: "Cervical, dorsal or lumbar spine imaging for pain and injuries." },
      { name: "X-Ray Bone", desc: "Detects fractures, infections and bone abnormalities." },
      { name: "X-Ray Joint", desc: "Imaging of knee, shoulder, hip and other joints for arthritis & injury." },
    ],
  },
  {
    id: "interventions",
    title: "Interventions",
    icon: "Syringe",
    image: IMAGES.interventions,
    blurb:
      "Minimally invasive, image-guided interventional procedures performed safely by expert radiologists.",
    services: [
      { name: "USG-Guided FNAC", desc: "Ultrasound-guided fine-needle aspiration cytology for accurate, targeted sampling of lumps and nodules." },
      { name: "USG-Guided Biopsy", desc: "Image-guided core biopsy of organs and soft tissue for precise tissue diagnosis." },
      { name: "USG-Guided Aspiration", desc: "Drainage and aspiration of cysts, abscesses and fluid collections under ultrasound guidance." },
      { name: "Pleural / Ascitic Tapping", desc: "Guided removal of fluid from the chest (pleural) or abdomen (ascitic) for relief and testing." },
      { name: "Pigtail Catheter Drainage", desc: "Image-guided catheter placement to continuously drain collections and abscesses." },
      { name: "Thyroid Nodule FNAC", desc: "Precise ultrasound-guided sampling of thyroid nodules for cytological evaluation." },
    ],
  },
];

export const WHY_CHOOSE_US = [
  { icon: "Stethoscope", title: "Experienced Radiologists", desc: "Reports reviewed by senior, qualified radiologists you can trust." },
  { icon: "Cpu", title: "Advanced Imaging Technology", desc: "Latest ultrasound, digital X-ray and lab equipment." },
  { icon: "ClipboardCheck", title: "Accurate Reports", desc: "Precision diagnostics with rigorous quality checks." },
  { icon: "IndianRupee", title: "Affordable Pricing", desc: "Transparent, fair pricing with no hidden charges." },
  { icon: "Timer", title: "Quick Turnaround Time", desc: "Most reports delivered the same day." },
  { icon: "HeartHandshake", title: "Patient-Centric Care", desc: "Warm, comfortable and dignified care for every patient." },
];

export const TESTIMONIALS = [
  { name: "Kavita Yadav", area: "Gomti Nagar", rating: 5, image: IMAGES.patient3, text: "Got my ultrasound done here. Extremely clean facility and the staff was very professional. Reports were accurate and ready the same day!" },
  { name: "Avinash Komaturi", area: "Hazratganj", rating: 5, image: IMAGES.patient1, text: "Best diagnostic center in Lucknow. The radiologist explained everything patiently. Quick X-ray and very reasonable pricing." },
  { name: "Anshika Sharma", area: "Adarsh Nagar", rating: 5, image: IMAGES.patient2, text: "Booked my blood tests through WhatsApp. Smooth experience, hygienic lab and friendly staff. Highly recommend UNIRAD." },
];

export const FAQS = [
  { q: "Do I need an appointment for tests?", a: "Walk-ins are welcome, but we recommend booking an appointment or messaging us on WhatsApp to minimise waiting time." },
  { q: "How soon will I get my reports?", a: "Most ultrasound and X-ray reports are available the same day. Pathology reports are typically ready within 24 hours." },
  { q: "Is fasting required for blood tests?", a: "Some tests like blood sugar and lipid profile require 8–12 hours of fasting. Our team will guide you when you book." },
  { q: "Do you provide digital reports?", a: "Yes, we can share your reports digitally on WhatsApp or email in addition to printed copies." },
  { q: "Are walk-ins accepted on Sunday?", a: "Yes, we are open on Sundays from 8:00 AM to 2:00 PM for your convenience." },
];
